// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGThumbsUp = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M2.143 4.714c.236 0 .429.193.429.429v5.143c0 .236-.193.428-.43.428-.235 0-.428-.192-.428-.428V5.143c0-.236.193-.429.429-.429z"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.661 1.286c.545 0 1.05.27 1.35.724.3.455.352 1.025.138 1.526L6.647 4.71h1.496c.02 0 .038.002.057.004h.83c.707 0 1.286.58 1.286 1.286 0 .33-.127.63-.332.857.205.228.332.528.332.857 0 .592-.403 1.093-.948 1.239.06.146.09.309.09.476 0 .707-.578 1.285-1.285 1.285H6.887l-.031-.001.001.002H5.572c-1.183 0-2.143-.96-2.143-2.143V5.327c0-.373.098-.741.283-1.062L5.289 1.5c.077-.133.218-.214.372-.214zM4.453 4.684c-.112.193-.171.416-.171.639v3.244c0 .708.578 1.286 1.285 1.286h1.286c.02 0 .038.002.057.004h1.263c.236 0 .429-.193.429-.428 0-.236-.193-.429-.429-.429s-.429-.193-.429-.428c0-.236.193-.429.43-.429h.856c.236 0 .429-.193.429-.429 0-.235-.193-.428-.429-.428h-.857c-.236 0-.429-.193-.429-.429 0-.235.193-.428.43-.428h.856l.044-.002c.215-.022.385-.206.385-.427 0-.235-.193-.428-.429-.428H6.46c-.02 0-.039-.002-.058-.005h-.4c-.147 0-.28-.073-.357-.193-.081-.12-.094-.27-.038-.403l.754-1.77c.103-.24.077-.5-.064-.72-.099-.15-.24-.256-.407-.308L4.453 4.684z"
  })]
}));
SVGThumbsUp.displayName = 'SVGThumbsUp';
export default SVGThumbsUp;